<!-- Main content -->
<section class="content-header">
  <h1 i18n="@@PowerBiViewerAdministration">
      Power Bi Viewer Administration
  </h1>
  <ol class="breadcrumb">
    <li><a href="#"><em class="fa fa-dashboard"></em> <span i18n="@@Homepage">Homepage</span></a></li>
    <li class="active" i18n="@@Administration">Administration</li>
  </ol>
</section>
<section class="content">
  <div class="box">
    <div class="box-header with-border">
      <h3 class="box-title" i18n="@@Workspaces">Workspaces</h3>
    </div>
    <div class="box-body">
      <div class="col-md-3">
        <table class="table table-hover table-bordered" >
          <tbody *ngIf="!loadingGroups else loading" class="cursor-pointer">
            <tr *ngFor="let group of GroupsEmbedded" (click)="loadReportsAndDashoardsOfGroup(group)">
                <td>{{group.name}} <span class="label label-danger" *ngIf="!group.isOnDedicatedCapacity"> <small class="fa fa-warning"></small></span></td>
            <tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-9" id="ReportsAndDashboardsContainer">
          <div *ngIf="ReportsEmbedded || DashboardsEmbedded" >
            <div class="mb-15">
                <h3>{{SelectedGroup.name}}</h3>
                <h5><span class="label label-danger"
                        *ngIf="!SelectedGroup.isOnDedicatedCapacity"
                        i18n="@@PowerBiWarningCapacity">Warning, no PowerBiEmbeddedded capacity activated.</span>
                </h5>
            </div>

            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
                <li class="active"><a href="#tab_1-1" data-toggle="tab" i18n="@@Reports">Reports</a></li>
                <li><a href="#tab_2-2" data-toggle="tab" i18n="@@Dashboards">Dashboards</a></li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="tab_1-1">
                  <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="col" i18n="@@Name">Name</th>
                            <th class="col-6"></th>
                            <th class="col text-centered" i18n="@@Actions">Actions</th>
                        </tr>
                    </thead>
                      <tbody *ngIf="!loadingReportAndDashboard  else loading" >
                        <tr *ngFor="let report of ReportsEmbedded">
                          <td class="col" [ngClass]="{'text-info': report.id == 0 }">{{ report.customName }} <span class="fs-10"><em *ngIf="report.id != 0">(ID:{{ report.id }})</em><em *ngIf="report.id == 0">(NEW)</em></span></td>
                          <td class="col-6"></td>
                          <td class="col">
                            <div class="col-md-5 spacer"></div>
                            <div class="col-md-3">
                              <button  class="btn btn-xs btn-edit"
                                      data-id="{{ report.azureObjectId }}" (click)="changeEditGroupObject(report)" >
                                  <em class="fa fa-edit"></em>&nbsp;<span i18n="@@Edit">Edit</span>
                              </button>
                            </div>
                            <div class="col-md-4">
                              <a href="https://app.powerbi.com/groups/{{ SelectedGroup.id}}/reports/{{report.azureObjectId}}/" target="_blank">
                                <button class="btn btn-success btn-xs ml-2" href="" ><em class="fa fa-link"></em>&nbsp;<span i18n="@@ViewInPowerBiApp">View in PowerBi app</span></button></a>
                            </div>
                          </td>
                        </tr>
                        <tr *ngFor="let report of ReportsNotInAzure">
                          <td *ngIf="report.customName != null else noNameBlock" class="col">
                            {{ report.customName }} <span class="fs-14">(ID:{{ report.id }})&nbsp;
                              <span class="label label-danger" i18n="@@reportNoLoggerAvailableInAzure">
                                This report is no longer available in Azure
                              </span>
                            </span>
                          </td>
                          <ng-template #noNameBlock>
                            <td>
                              NO_NAME_REPORT <span class="fs-14">(ID:{{ report.id }})&nbsp;
                                <span class="label label-danger" i18n="@@reportNoLoggerAvailableInAzure">This report is no longer available in
                                  Azure
                                </span>
                              </span>
                            </td>
                          </ng-template>
                          <td class="col-6"></td>
                          <td class="col">
                            <div class="col-md-5 spacer"></div>
                            <div class="col-md-3 ">
                              <button class="btn btn-view btn-xs "  data-id="{{ report.azureObjectId }}" (click)="viewBIObject(report,false)" >
                                <em class="fa fa-eye"></em>&nbsp;<span >View</span>
                              </button>
                            </div>
                            <div class="col-md-4">
                              <button class="btn btn-danger btn-xs "  (click)="openDeleteConfirmModal(report)" data-toggle="modal" data-target="#confirmDeletePBIO" >
                                <em class="fa fa-remove"></em>&nbsp;<span i18n="@@Remove">Remove</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>

                  </table>
                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_2-2">
                  <table class="table table-hover" >
                      <thead>
                          <tr>
                              <th i18n="@@Name">Name</th>
                              <th class="col-6"></th>
                              <th class="text-centered" i18n="@@Actions">Actions</th>
                          </tr>
                      </thead>
                        <tbody *ngIf="!loadingReportAndDashboard else loadingReport">
                        <tr *ngFor="let dashboard of DashboardsEmbedded">
                          <td [ngClass]="{'text-info': dashboard.id == 0 }" class="col">
                            {{dashboard.customName}}
                            <span class="fs-10" >
                              <em *ngIf="dashboard.id != 0">(ID:{{ dashboard.id }})</em>
                              <em *ngIf="dashboard.id == 0">(NEW)</em>
                            </span>
                          </td>
                          <td class="col-6"></td>
                          <td class="col">
                            <div class="col-md-5 spacer"></div>
                            <div class="col-md-3 ">
                                <!-- <button  class="btnDashboardEdit btn btn-primary btn-xs " -->
                                <button  class="btn btn-xs btn-edit "
                                        href="#modal-editAzureObject" data-id="{{ dashboard.id }}"
                                        (click)="changeEditDashboardObject(dashboard)" >
                                    <em class="fa fa-edit"></em>&nbsp;<span i18n="@@Edit">Edit</span>
                                </button>
                            </div>
                            <div class="col-md-4">
                              <a href="https://app.powerbi.com/groups/{{ SelectedGroup.id}}/reports/{{dashboard.id}}/" target="_blank">
                                <button class="btn btn-success btn-xs " href="" >
                                  <em class="fa fa-link"></em>&nbsp;<span i18n="@@ViewInPowerBiApp">View in PowerBi app</span>
                                </button>
                              </a>
                            </div>
                          </td>
                        <tr>
                        <tr *ngFor="let dashboard of DashboardsNotInAzure">
                          <td *ngIf="dashboard.customName != null; else noNameBlock">
                            {{ dashboard.customName }} <span class="fs-14">(ID:{{ dashboard.id }})&nbsp;
                              <span class="label label-danger" i18n="@@dashboardNoLoggerAvailableInAzure">
                                This dashboard is no longer available in Azure
                              </span>
                            </span>
                          </td>
                          <ng-template #noNameBlock>
                            <td>
                              NO_NAME_DASHBOARD <span class="fs-14">(ID:{{ dashboard.id }})&nbsp;
                                <span class="label label-danger" i18n="@@dashboardNoLoggerAvailableInAzure">This dashboard is no longer
                                  available in Azure
                                </span>
                              </span>
                            </td>
                          </ng-template>
                          <td class="col-6"></td>
                          <td class="col">
                            <div class="col-md-5 spacer"></div>
                            <div class="col-md-3 ">
                              <button class="btn btn-view btn-xs " (click)="viewBIObject(dashboard,true)">
                                <em class="fa fa-eye"></em>&nbsp;<span >View</span>
                              </button>
                            </div>
                            <div class="col-md-4 ">
                              <button class="btn btn-danger btn-xs " (click)="openDeleteConfirmModal(dashboard)" data-toggle="modal" data-target="#confirmDeletePBIO" >
                                <em class="fa fa-remove"></em>&nbsp;<span i18n="@@Remove">Remove</span>
                              </button>
                            </div>

                          </td>
                        </tr>
                    </tbody>
                    <ng-template #loadingReport>
                      <tbody class="self-centered" >
                      <tr>
                          <td colspan="4"><em class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></em>&nbsp;<span i18n="@@InProgress">In progresss</span></td>
                      </tr>
                      </tbody>
                  </ng-template>
                  </table>
                </div>
              </div>
              <!-- /.tab-content -->
            </div>
          </div>
      </div>
    </div>
    <!-- /.box-body -->
  </div>
</section>
<!-- /.content -->
<div class="control-sidebar-bg"></div>

<ng-template #loading>
    <tbody class="self-centered" >
    <tr>
         <td  colspan="8"><em class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></em>&nbsp;<span i18n="@@InProgress">In progress</span></td>
    </tr>
    </tbody>
</ng-template>

<div class="modal fade in" id="modal-editAzureObject" tabindex="-1" role="dialog" *ngIf="editGroup != null"  [ngStyle]="{'display':displayModelEdit}">
    <div class="modal-dialog modal-lg ">
        <div class="modal-content">
          <app-form-azure-object (closeModalClicked)="changeEditObjectModal($event)" [isReadOnly]="isReadOnly" [isDashboard]="isDashboardToEdit" [objectToEdit]="editGroup" [GroupSelected]="SelectedGroup" [azureWorkspaceId]="azureWorkspaceId"></app-form-azure-object>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>


<!-- Deletion Confirm Modal -->
<div class="modal" id="confirmDeletePBIO" tabindex="-1" role="dialog" aria-labelledby="ConfirmDeletePBIO" aria-hidden="true" [ngClass]="{'show': showDeleteConfirmModal}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header confirm-modal-header ">
        <h5 class="modal-title text-centered" id="deleteConfirmTitle"><span class="fa fa-exclamation-circle"></span> <span
            i18n="@@deletion"> DELETION </span><span class="fa fa-exclamation-circle"></span> </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)=closeDeleteConfirmModal()>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-centered" i18n="@@PleaseConfirmYourChange">Please confirm
        your change.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary pull-left cancel-button" data-dismiss="modal"
          (click)="cancelDeletePBIO()"> <i class="fa fa-undo arrow-icon mr-5" aria-hidden="true"></i><span i18n="@@cancel">Cancel</span></button>
        <button type="button" class="btn btn-primary " data-dismiss="modal" (click)="confirmDeletePBIO()"
          i18n="@@confirm">Confirm</button>
      </div>
    </div>
  </div>
</div>
